import partner from '../../fields/other/partner';

export const MUTATION_ADD_PARTNER = /* GraphQL */ `
	mutation($input: PartnerInput!) {
		addPartner(input: $input) {
			${partner}
		}
	}
`;
